import React, { useState } from 'react';
import { connect } from 'react-redux';
import {
    Sidebar,
    WarningModal,
    NotificationSystem,
    updateTabEvents,
    SidebarMenuMapType,
    EmailConfirmationNotification,
} from 'components';
import { Location } from 'history';
import { IAuthResult } from '../../api/ApiClient';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { useShowGlobalErrorModal } from 'hooks';
import { push } from 'connected-react-router';
import sidebarTabs from '../../routes/SidebarTabs';

const PROFILE_TABS = [
    {
        path: '/my-profile',
        name: 'Настройки профиля',
        mini: 'НП',
    },
];
const SidebarContainer = ({
    onFetchProfile,
    startEventStatePoll,
    stopEventStatePoll,
    events,
    errors,
    onPush,
    notifications,
    cleanNotifications,
    auth,
    location,
    sendConfirmationEmail,
    onLogout,
}: Props) => {
    const TABS = sidebarTabs;
    const [tabs, setTabs] = useState(TABS);

    React.useEffect(() => {
        onFetchProfile();
        if (process.env.REACT_APP_LOCAL_RUN_TESTS !== 'true') {
            startEventStatePoll();
        }
        return () => {
            stopEventStatePoll();
        };
    }, []);

    React.useEffect(() => {
        setTabs(TABS.map(t => updateTabEvents(t, events, menuEventsMap)));
    }, [events]);

    const { showModal, toggleModal } = useShowGlobalErrorModal(errors);
    const { profile } = (auth || {}) as IAuthResult;
    return (
        <>
            <Sidebar
              profile={profile}
              location={location}
              profileTabs={PROFILE_TABS}
              tabs={tabs}
              onLogout={onLogout}
            />
            {errors.error && errors.handler === 'global' && !errors.error.failures
                ? (
                    <WarningModal
                      title={errors.error.message}
                      show={showModal}
                      onHide={() => toggleModal(false)}
                      onAccess={() => toggleModal(false)}
                      accessBtnTittle="Вернуться"
                      titleClassNames="text-danger"
                    >
                        <p>Код ошибки:{errors.error.code}</p>
                        <p>Тип ошибки:{errors.error.type}</p>
                    </WarningModal>
                )
                : null}
            <NotificationSystem
              notifications={notifications}
              cleanNotifications={cleanNotifications}
            />
            <EmailConfirmationNotification
              profile={profile}
              onPush={onPush}
              sendConfirmationEmail={captcha => sendConfirmationEmail({ captcha })}
              cleanNotifications={cleanNotifications}
              apiError={errors.error}
            />
        </>
    );
};

const mapState = (state: IRootState) => ({
    auth: state.auth,
    errors: state.errors,
    notifications: state.notifications,
    events: state.eventsState,
});
const mapDispatch = (dispatch: Dispatch) => ({
    onPush: (key: string) => dispatch(push(key)),
    onLogout: dispatch.auth.logout,
    onFetchProfile: dispatch.auth.fetchProfile,
    cleanNotifications: dispatch.notifications.clean,
    startEventStatePoll: dispatch.eventsState.startEventStatePoll,
    stopEventStatePoll: dispatch.eventsState.stopEventStatePoll,
    sendConfirmationEmail: dispatch.auth.sendConfirmationEmailAsync,
});

type connectedProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>
interface OwnProps {
    location: Location;
}
type Props = connectedProps & OwnProps;
export default connect(mapState, mapDispatch)(SidebarContainer);

const menuEventsMap: SidebarMenuMapType = {
    'Заявки на аккредитацию': ['ExamApplicationsPaymentRequired', 'ExamApplications'],
};
